import React from 'react';
import AdminMasterLayout from '../../../layouts/gcadmin/adminMasterLayout/AdminMasterLayout';
import ManageUsers from '../../../subsreens/gcadmin/manageusers/ManageUsers';


const ManageUsersPage = () => {
    return(
       <AdminMasterLayout>
        <ManageUsers/>
       </AdminMasterLayout>
    )
}

export default ManageUsersPage;